import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { HttpError, isError } from "../helpers/Error"
import { INTEGRATION_KEY } from "./Constants"
import { ExternalForm } from "./wix/types"

class ExternalFormService {
    static async getAllForms(integrationKey: INTEGRATION_KEY): Promise<ExternalForm[] | HttpError> {
        const res = await AppContext.getApiClient().get("/" + integrationKey + "/external-forms")
        if (isError(res)) {
            return res as HttpError
        }
        return res as ExternalForm[]
    }
}

export default ExternalFormService


// WEBPACK FOOTER //
// ./src/state/integration/ExternalFormService.ts